// Simple in-memory cache keyed by company:workspace
const audienceCache = new Map();
function key(companyId, workspaceId) {
    return `${companyId}:${workspaceId}`;
}
export function getAudienceCache(companyId, workspaceId) {
    return audienceCache.get(key(companyId, workspaceId));
}
export function setAudienceCache(companyId, workspaceId, entry) {
    audienceCache.set(key(companyId, workspaceId), entry);
}
export function clearAudienceCache(companyId, workspaceId) {
    audienceCache.delete(key(companyId, workspaceId));
}
